/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import React from "react";
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate";

export default function Footer({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { sites, unitHeads, dateFounded } = formField;

  return (
    <Box mt={3}>
      <Box mb={4}>
        <Typography variant="subtitle1" fontStyle="italic" fontSize={14} fontWeight={"bold"}>
          (Ghi rõ tên tài liệu, bản chính hay bản sao)
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            label={sites.label}
            name={sites.name}
            value={values.sites}
            error={errors.sites && touched.sites}
            success={values.sites?.toString().length > 0 && !errors.sites}
          />
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            label={unitHeads.label}
            name={unitHeads.name}
            value={values.unitHeads}
            error={errors.unitHeads && touched.unitHeads}
            success={values.unitHeads?.toString().length > 0 && !errors.unitHeads}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            label={dateFounded.label}
            name={dateFounded.name}
            error={errors.dateFounded && touched.dateFounded}
            success={values.dateFounded?.toString().length > 0 && !errors.dateFounded}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
